import createReducer from 'redux/lib/reducerConfig';
import { PRICING_OPTIONS } from 'components/MarketPrice/Filter/PricingStatusSelector';
import { BENCHMARK_OPTIONS } from 'components/Controls/BenchmarkStatusSelector';
import { ActionTypes as SharedActionTypes, sharedPages } from 'redux/marketPrice/sharedFilter';
import { PricedStatus, SurveyJobSearchField } from 'types';
import { selectDefaultPlans } from '../selectors';

const ActionTypes = {
  SET_FILTER: 'MARKET_PRICE/SET_FILTER',
  RESET_FILTER: 'MARKET_PRICE/RESET_FILTER',
};

export const filterInitialState = {
  plan: [],
  payMarket: [],
  jobFamily: [],
  jobSubFamily: [],
  jobLevel: [],
  tags: [],
  priced: PRICING_OPTIONS.all.value,
  benchmark: BENCHMARK_OPTIONS.all.value,
  search: [],
  searchFields: Object.values(SurveyJobSearchField),
  effectiveDate: null,
  grade: [],
  salaryRangeTypeOfPay: [],
};

export const setFilter = (filter) => ({
  type: ActionTypes.SET_FILTER,
  payload: filter,
});

export const resetFilter = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.RESET_FILTER,
    payload: {
      ...filterInitialState,
      plan: selectDefaultPlans(getState()),
    },
  });
};

export const filterReducer = createReducer(
  filterInitialState,
  {
    [ActionTypes.SET_FILTER]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
    [ActionTypes.RESET_FILTER]: (state, { payload }) => {
      return payload;
    },
    [SharedActionTypes.SET_SHARED_FILTER]: (state, { payload, page }) => {
      if (page !== sharedPages.mass && page !== sharedPages.single) {
        return { ...state, ...payload };
      }

      const { plan, ...sharedFilter } = payload;
      const updatedFilter = {
        ...state,
        ...sharedFilter,
        plan: Array.isArray(plan) && plan.length > 0 ? [plan[0]] : plan,
      };

      // priced/benchmark are reset to their defaults only on this single<->mass
      // composites navigation (see the early return above) - their controls
      // don't exist on /mapping/job, so navigating there never hits this branch
      // and never resets them. Without this, switching between single-plan and
      // mass composites could silently carry over a priced/benchmark value the
      // destination page's filter bar has no way to show or clear.
      const resetToDefault = {};
      if (state.priced !== PricedStatus.ALL) {
        resetToDefault.priced = PricedStatus.ALL;
      }
      if (state.benchmark !== BENCHMARK_OPTIONS.all.value) {
        resetToDefault.benchmark = BENCHMARK_OPTIONS.all.value;
      }

      return { ...updatedFilter, ...resetToDefault };
    },
  },
);
